import unescapedText from 'I18n/utils/unescapedText';
import { POSITIVE, NEGATIVE } from 'conversations-message-history/customer-agent-feedback-message/constants/messageTypes';
import styled from 'styled-components';
import SVGThumbsDown from 'visitor-ui-component-library-icons/icons/SVGThumbsDown';
import SVGThumbsUp from 'visitor-ui-component-library-icons/icons/SVGThumbsUp';
import { NEUTRAL_1600, NEUTRAL_400, WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import VizExTooltip from 'visitor-ui-component-library/tooltip/VizExTooltip';
import { TOOLTIP_ARROW_STYLE, TOOLTIP_CONTENT_STYLE } from '../shared/tooltipStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ICON_STYLE = {
  color: NEUTRAL_1600,
  fill: NEUTRAL_1600,
  width: 16,
  height: 16
};
const FeedbackButtonsContainer = styled.div.withConfig({
  displayName: "MessageFeedbackButtons__FeedbackButtonsContainer"
})(["display:flex;gap:8px;align-items:center;flex-shrink:0;"]);
const IconButton = styled.button.withConfig({
  displayName: "MessageFeedbackButtons__IconButton"
})(["background:", ";border:none;border-radius:4px;padding:0;width:24px;height:24px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background-color 150ms ease;"], ({
  $isSelected
}) => $isSelected ? NEUTRAL_400 : 'transparent');
function FeedbackButton({
  feedbackType,
  isSelected,
  label,
  onFeedbackClick
}) {
  const Icon = feedbackType === POSITIVE ? SVGThumbsUp : SVGThumbsDown;
  return /*#__PURE__*/_jsx(VizExTooltip, {
    content: label,
    placement: "top left",
    backgroundColor: WHITE,
    textColor: NEUTRAL_1600,
    contentStyle: TOOLTIP_CONTENT_STYLE,
    arrowStyle: TOOLTIP_ARROW_STYLE,
    children: /*#__PURE__*/_jsx(IconButton, {
      type: "button",
      $isSelected: isSelected,
      onClick: () => onFeedbackClick(feedbackType),
      "aria-label": label,
      "aria-pressed": isSelected,
      children: /*#__PURE__*/_jsx(Icon, {
        style: ICON_STYLE
      })
    })
  });
}
FeedbackButton.displayName = 'FeedbackButton';
function MessageFeedbackButtons({
  onFeedbackClick,
  selectedFeedback
}) {
  return /*#__PURE__*/_jsxs(FeedbackButtonsContainer, {
    children: [/*#__PURE__*/_jsx(FeedbackButton, {
      feedbackType: POSITIVE,
      isSelected: selectedFeedback === POSITIVE,
      label: unescapedText('conversations-visitor-message-history.feedback.helpful'),
      onFeedbackClick: onFeedbackClick
    }), /*#__PURE__*/_jsx(FeedbackButton, {
      feedbackType: NEGATIVE,
      isSelected: selectedFeedback === NEGATIVE,
      label: unescapedText('conversations-visitor-message-history.feedback.notHelpful'),
      onFeedbackClick: onFeedbackClick
    })]
  });
}
MessageFeedbackButtons.displayName = 'MessageFeedbackButtons';
export default MessageFeedbackButtons;